import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { downGradeOfferModalTexts } from 'src/common/config/TextMessage';
import { downGradeOfferModalSxs } from './newChangePlan';

interface OfferModalButtonsProps {
  isLocalSeo: boolean;
  isFromDeactivate: boolean;
  isOfferProcess: boolean;
  handleCloseDownGradeOfferModal: () => void;
  handleContinue: () => void;
}

const OfferModalButtons: React.FC<OfferModalButtonsProps> = ({
  isLocalSeo,
  isFromDeactivate,
  isOfferProcess,
  handleCloseDownGradeOfferModal,
  handleContinue
}) => {
  const getContinueButtonText = () => {
    if (isLocalSeo && isFromDeactivate) {
      return downGradeOfferModalTexts?.noThanksCancelSub;
    }
    if (isFromDeactivate) {
      return downGradeOfferModalTexts?.noThanksDeactivate;
    }
    return downGradeOfferModalTexts?.noThanks;
  };

  return (
    <Box sx={downGradeOfferModalSxs?.btnBoxSx}>
      <Button
        sx={downGradeOfferModalSxs?.btnSx}
        variant="outlined"
        onClick={handleCloseDownGradeOfferModal}
        fullWidth
        disabled={isOfferProcess}
      >
        <Typography sx={downGradeOfferModalSxs?.btnTextSx}>
          {downGradeOfferModalTexts?.goBack}
        </Typography>
      </Button>
      <Button
        sx={downGradeOfferModalSxs?.btnSx}
        variant="outlined"
        onClick={handleContinue}
        fullWidth
        disabled={isOfferProcess}
      >
        <Typography sx={downGradeOfferModalSxs?.btnTextSx}>
          {getContinueButtonText()}
        </Typography>
      </Button>
    </Box>
  );
};

export default OfferModalButtons;
